import Vue from 'vue'
import Vuetify, { VSnackbar, VBtn, VIcon } from 'vuetify/lib'
import VuetifyToast from 'vuetify-toast-snackbar-ng'

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon,
  },
})
Vue.use(VuetifyToast, {
  x: 'center',
  showClose: true,
  closeText: 'close',
  shorts: {
    success: {
      color: 'green',
      icon: 'mdi-check',
    },
    warning: {
      color: 'orange',
      icon: 'mdi-alert',
    },
    error: {
      color: 'red',
      icon: 'mdi-alert-circle-outline',
    },
  },
})

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#e61a43',
        accent: '#0062ff',
      },
    },
  },
})
